export enum FormSlideLayout {
    TWO_COLUMN_IMAGE_LEFT = 'TWO_COLUMN_IMAGE_LEFT',
    TWO_COLUMN_IMAGE_RIGHT = 'TWO_COLUMN_IMAGE_RIGHT',
    SINGLE_COLUMN_IMAGE_BACKGROUND = 'SINGLE_COLUMN_IMAGE_BACKGROUND',
    SINGLE_COLUMN_NO_BACKGROUND = 'SINGLE_COLUMN_NO_BACKGROUND',
    SINGLE_COLUMN_NO_BACKGROUND_LEFT_ALIGN = 'SINGLE_COLUMN_NO_BACKGROUND_LEFT_ALIGN'
}
